import React from 'react';

const Textarea = React.forwardRef(({
  label,
  placeholder,
  value,
  onChange,
  error,
  helper,
  disabled = false,
  required = false,
  rows = 4,
  ...props
}, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
          {label}
          {required && <span className="text-error-600 dark:text-error-500">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={`
          w-full px-4 py-2 border rounded-lg font-medium transition-colors resize-none
          focus:outline-none focus:ring-2 focus:ring-offset-0
          dark:bg-gray-800 dark:text-white dark:placeholder-gray-400
          ${error
            ? 'border-error-500 dark:border-error-500 focus:ring-error-500 bg-error-50 dark:bg-error-950'
            : 'border-gray-300 dark:border-gray-600 focus:ring-primary-500'
          }
          ${disabled ? 'bg-gray-100 dark:bg-gray-700 cursor-not-allowed opacity-60' : 'bg-white'}
        `}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-error-600 dark:text-error-500">{error}</p>}
      {helper && !error && <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{helper}</p>}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
